import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const assetApi = createApi({
  reducerPath: 'assetApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/contractor/assets' }),
  endpoints: (builder) => ({
    getAssets: builder.query({
      query: (searchParams = '') => searchParams,
      providesTags: ['Asset']
    }),
    getAsset: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['Asset']
    }),

    createAsset: builder.mutation({
      query: (assetData) => ({
        method: 'POST',
        body: assetData
      }),
    }),

    updateAsset: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Asset']
    })    
  })
})

export const {
  useGetAssetsQuery,
  useGetAssetQuery,
  useCreateAssetMutation,
  useUpdateAssetMutation
} = assetApi
